import axiosInstance from "../../utils/axiosInstance";
import { buildQueryParams } from './../../services/utility';

const list = async (params) => {
  const queryString = buildQueryParams(params);
  const response = await axiosInstance.get(`subscription/user-subscriptions?${queryString}`);
  return response.data.data;
};

const listUserSubscriptionPayments = async (params) => {
  const queryString = buildQueryParams(params);
  const response = await axiosInstance.get(`subscription/user-subscription-payments?${queryString}`);
  return response.data.data;
};

const listUserRedeemCode = async (params) => {
  const queryString = buildQueryParams(params);
  const response = await axiosInstance.get(`user/redeem-code?${queryString}`);
  return response.data.data;
};

const listUserCreditUsed = async (params) => {
  const queryString = buildQueryParams(params);
  const response = await axiosInstance.get(`user/credit-used?${queryString}`);
  return response.data.data;
}

const listLogsUserShot = async (params) => {
  const queryString = buildQueryParams(params);
  const response = await axiosInstance.get(`user/logs-user-shot?${queryString}`);
  return response.data.data;
}

const userSubscription = {
  list,
  listUserSubscriptionPayments,
  listUserRedeemCode,
  listUserCreditUsed,
  listLogsUserShot,
};

export default userSubscription;
